import { useState, useMemo } from "react";
import CommunityAreaChart, {
  CommunityAreaChartTabs,
  TABS,
} from "../MarketPlace/CommunityAreaChart";
import { useDashboardMarket } from "../CommonComponents/DashboardMarketSelect/DashboardMarketContext";
import "../Trading/Trading.css";

const formatDate = (value) => {
  if (!value) return "-";
  const date = new Date(value);
  if (Number.isNaN(date.getTime())) return "-";
  const day = String(date.getUTCDate()).padStart(2, "0");
  const month = String(date.getUTCMonth() + 1).padStart(2, "0");
  const year = date.getUTCFullYear();
  return `${day}-${month}-${year}`;
};

function MemberTradingGraph({ user }) {
  const [activeTab, setActiveTab] = useState(2);
  const activeButton = TABS[activeTab]?.duration ?? "Week";
  const { selectedMarket } = useDashboardMarket();

  const dateRange = useMemo(() => {
    const today = new Date();
    const userCreatedAt = user?.createdAt ? new Date(user.createdAt) : null;

    switch (activeButton) {
      case "Day":
        return formatDate(today);

      case "Week": {
        const weekStart = new Date(today);
        weekStart.setDate(today.getDate() - today.getDay());
        const startDate =
          userCreatedAt && weekStart < userCreatedAt
            ? userCreatedAt
            : weekStart;
        return `${formatDate(startDate)} - ${formatDate(today)}`;
      }

      case "Month": {
        const monthStart = new Date(today.getFullYear(), today.getMonth(), 1);
        const startDate =
          userCreatedAt && monthStart < userCreatedAt
            ? userCreatedAt
            : monthStart;
        return `${formatDate(startDate)} - ${formatDate(today)}`;
      }

      case "All Time":
        return userCreatedAt
          ? `${formatDate(userCreatedAt)} - ${formatDate(today)}`
          : "N/A";

      default:
        return "";
    }
  }, [activeButton, user?.createdAt]);

  return (
    <div
      className={`TradingBox memberTradingGraph d-flex flex-column ${
        user?.role !== "leader" ? "mw-100" : ""
      } `}
    >
      <div className="topTradingBox ">
        <div className="contentSide">
          <p className="name">Overall Performance</p>
          <p className="trading__date">
            <span>{dateRange}</span>
          </p>
        </div>

        <div className="switchSide">
          <CommunityAreaChartTabs
            activeTab={activeTab}
            onTabChange={setActiveTab}
          />
        </div>
      </div>

      <div className="chartBox">
        <CommunityAreaChart
          bare
          graphType="pnl"
          userId={user?._id}
          activeTab={activeTab}
          onTabChange={setActiveTab}
          market={selectedMarket}
        />
      </div>
    </div>
  );
}

export default MemberTradingGraph;
